import UsedAssemblyMaterials from './UsedAssemblyMaterials';


export default UsedAssemblyMaterials;